<template>
  <div class="role-content">
    <el-card shadow="hover" class="left-bar">
      <div class="search">

        <el-input v-model="searchVal" suffix-icon="el-icon-search" @blur="getFilter"
          class="priv-select input-with-select">
          <el-select v-model="value" slot="prepend" :placeholder="$t('message.placeholder.search')" @change="getFilter">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-input>
        <el-button icon="el-icon-edit" @click="addPriv"></el-button>
      </div>
      <div class="list-content" v-loading="loading">

        <el-table ref="singleTable" :data="privList" style="width: 100%" height="calc(100vh - 240px )"
          highlight-current-row @current-change="handleCurrentChange">
          <el-table-column prop="name" label="名称" sortable>
          </el-table-column>
          <el-table-column prop="typeValue" label="权限类型" sortable width="100">
          </el-table-column>
          <el-table-column prop="className" label="数据分类" width="140" sortable>
          </el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <el-button class="el-icon-delete" @click.native.prevent="del(scope.row)" type="text" size="small">
              </el-button>
            </template>
          </el-table-column>

        </el-table>

      </div>
    </el-card>
    <el-card shadow="hover" class="route-content">
      <div style="margin-bottom: 15px;">
        <Tab :data="tabList" @click="tabClick"></Tab>
      </div>
      <router-view :privData="privData" :key="getKey" @setRefresh="refreshData"></router-view>
    </el-card>
    <el-dialog :close-on-click-modal="false" :title="$t('message.title.editPrivilege')" v-if="dialogVisible"
      :visible.sync="dialogVisible" width="50%" @close="closeEdit">
      <privs-form ref="privsForm" @submit="submitForm"></privs-form>
    </el-dialog>
  </div>
</template>


<script>
import axios from "axios";
import ListData from "../../workflow/infoShow/listData";
import Tab from "../configComp/Tab.vue";
import privsForm from "./privsForm.vue";
export default {
  name: "Privs",
  components: {
    ListData,
    privsForm,
    Tab
  },
  data() {
    return {

      searchVal: '',

      privList: [],
      privData: {},
      options: [],
      value: '',

      tableName: [
        this.$t("message.transform.choices"),
        this.$t("message.transform.selected"),
      ],
      filterType: [],
      allList: [],

      dialogVisible: false,

      showTable: false,
      tableData: [],
      showTitle: '',
      loading: false,
      tabList: [
        { label: "详细信息", id: 1, path: '/privsInfo' },
        { label: "角色列表", id: 2, path: '/privsRole' },
        { label: "用户列表", id: 1, path: '/privsUser' },
      ]
    };
  },
  computed: {
    getKey() {
      const { path, query } = this.$route
      return path + query.id
    }
  },
  watch: {
    searchVal() {
      this.getFilter()
    }
  },
  methods: {
    handleCurrentChange(val) {
      // this.currentRow = val;
      this.getItem(val)
    },
    getFilter() {
      this.privList = this.allList.filter(i => {
        const id = this.value == 99 ? i.type : this.value;
        return id == i.type && i.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) !== -1;
      })
    },

    addPriv() {
      this.dialogVisible = true;
      // this.privDataList = {};
      this.privData = {}
    },


    getActive(item) {
      const { query } = this.$route;
      if (item.id === query.id) {
        return 'activeList'
      }
      return ''
    },

    getItem(item) {
      console.log(item);

      const path = '/privs/privsInfo';
      const query = item || this.allList[0]
      this.privData = query;
      console.log(query);

      this.$refs.singleTable.setCurrentRow(query);
      this.$router.push({ path, query });
    },

    tabClick(e) {
      // let query = this.userInfo;
      // const query = {};
      const { path, query } = this.$route;
      console.log(e);
      this.$router.push({ path: '/privs' + e.path, query });
    },

    async getData() {
      this.loading = true
      const { data } = await axios.get("pmdm/admin/priv/getAllPrivType");
      console.log(12);
      if (data.code == 200) {
        const { privType } = data.object;
        this.options = [{ id: 99, name: '全部' }, ...privType];
        this.value = 99;

      }

    },
    getAllPriv() {
      return axios.get("pmdm/admin/priv/getAll");
    },

    closeAdd() {
      // this.$refs.addFormRef.clearValidate();
      this.applyTo = false;
      this.privsForm = {};
    },
    closeEdit() {
      // this.$refs.editFormRef.clearValidate();
      this.privsForm = {};
    },

    async submitForm(e) {
      const { data } = await axios.post("pmdm/admin/priv/save", e);
      if (data.code == 200) {
        this.$message.success(data.message);
        const item = data.object;
        console.log(item);

        this.allList.push(item);
        this.getFilter();
        this.dialogVisible = false;
        // this.queryMap.name = ''
      } else {
        this.$message.error(data.message);
      }
    },
    refreshData(obj) {

      const index = this.allList.findIndex(i => i.id === obj.id);
      this.$set(this.allList, index, obj)
      this.getFilter();
    },


    delItem(item) {

      axios
        .get("pmdm/admin/priv/del?id=" + item.id)
        .then(res => {
          if (res.data.code == 200) {
            console.log(res);
            this.$message({
              type: "success",
              message: res.data.message,
            });
            const { query } = this.$route;
            let index
            if (item.id === query.id) {
              index = this.allList.findIndex(i => i.id === item.id);
              console.log(this.allList[index], index);
            }
            this.allList = this.allList.filter(i => i.id !== item.id);
            this.getFilter();
            index && this.getItem(this.allList[index])
          }
        })
        .catch(function (error) {
        });
    },
    async del(item) {
      this.$confirm(
        this.$t("message.confirm.deleteData"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.delItem(item);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },

  },
  mounted() {

    this.getAllPriv().then(res => {

      const { code, object } = res.data

      if (code == 200) {
        const { privs } = object
        this.allList = privs;
        this.privList = this.allList;

        const { item } = this.$route.query;
        console.log(item);
        if (item) {
          this.$router.push({ path: '/privs/privsInfo', query: item })
        }
        if (!item) {
          this.getItem(this.allList[0])
        }
      }
    }).finally(() => {
      this.loading = false
    })


  },
  created() {
    this.getData();
  },
};
</script>

<style>
.priv-select .el-select .el-input {
  width: 120px;
}

.priv-select.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>

<style scoped>
.role-content {
  display: flex;
  padding: 10px;
  gap: 10px;
}

.left-bar {
  /* width: 460px; */
  flex-basis: 560px;
  flex-grow: 0;
  flex-shrink: 0;
}

.search {
  display: flex;
  margin: 8px 5px;
  margin-right: 0;
  gap: 8px;
}

.list-content {
  /* padding: 0 15px; */
  /* height: calc(100vh - 240px); */
  overflow-y: auto;
}

.route-content {
  flex: 1 1 auto;
  padding: 0 15px;
}

.role-item {
  font-size: 12px;
  margin: 3px;
  cursor: pointer;
  padding: 3px 5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

.role-label {
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.role-item:hover {
  /* color: #4b91ff; */
  background-color: #f5f7fa;
}

.activeList {
  /* margin: 3px;
  cursor: pointer;
  padding: 6px 5px; */
  background: #409EFF;
  color: #fff;
}

.activeList:hover {
  background: #409EFF;
}

.del-item {
  margin-left: auto;
  /* color: #f5f7fa; */
}

.activeList>.del-item {

  color: #f5f7fa;
  /* pointer-events: none; */
}
</style>
